import React from 'react'

const Manual_ordenes_compra_compra_rapida = () => {
  return (
    <>
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
        <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Órdenes de Compra - Compra Rápida
        </h2>
        <p className="text-lg text-gray-700 mb-6">
        Esta guía ofrece un enfoque sencillo para crear órdenes de compra rápidas, agilizando así el proceso
        y optimizando su flujo de trabajo de compras.
        </p>
        <iframe

        src="https://scribehow.com/embed/Ordenes_de_Compra__Compra_Rapida__wCWIbKDmRniwKoUEEz3Cdw?as=scrollable"
        className="scribe-iframe-general-179"
        width="100%"
        height="5950"
        allowFullScreen
        style={{ border: 0, minHeight: '640px' }}
        ></iframe>
        </div>
    </div>
    </>
  )
}

export default Manual_ordenes_compra_compra_rapida